'use strict';

const _ = require('lodash');

const OverlayListController = function ($scope, $rootScope, Flux, NavActions, SaturnGrowl, IdentityService) {

  const vm = this;
  const OverlayStore = Flux.Store.get('OverlayStore');
  const MapActions = Flux.Actions.get('MapActions');

  vm.overlays = [];

  vm.groupedList = [];
  vm.filteredList = [];
  vm.searchTerm = '';

  vm.isBetaUser = IdentityService.isBetaUser();

  // Format overlay to display in list widget
  const formatOverlay = (overlay) => {

    return {
      name : overlay.name,
      id : overlay.id
    };
  };

  const _loadOverlays = () => {

    const available = OverlayStore.get('available');
    if (available) {
      vm.overlays = available.map(formatOverlay);
      const current = OverlayStore.get('current');
      vm.groupedList = _.chain(available)
      .groupBy('category')
      .map((overlays) => {
        return {
          category: overlays[0].category,
          list: overlays
        };
      })
      .value();

      vm.overlaysSelected = _.indexBy(current, 'id');
    }
    else {
      vm.overlays = {};
      vm.overlaysSelected = {};
    }
  };

  // TODO: This is repeated in several navLeft children directives.
  // Refactor to a central place
  vm.closeDrawer = (options) => {

    options = options || {};
    if (options.prompt) {
      $rootScope.$broadcast(options.prompt);
    }
    else {
      NavActions.CloseDrawer.dispatch();
    }
  };

  vm.editOverlay = (overlay, $event) => {

    $event.stopPropagation(); // Stop propagation to prevent activation on list item
    MapActions.EditOverlayStart.dispatch(overlay.id);
  };

  vm.hasDeletePermissions = (overlay) => {

    const permissions = OverlayStore.getPermissions(overlay.id);
    return permissions.delete || permissions.all;
  };

  vm.deleteOverlay = (overlay, $event) => {

    $event.stopPropagation(); // Stop propagation to prevent activation on list item
    $rootScope.$broadcast('dialog:overlay:promptDelete', {
      id: overlay.id
    });
  };

  $scope.$on('dialog:overlay:confirmDelete', (ev, data) => {

    MapActions.DestroyOverlay.dispatch(data.id);
    OverlayStore.once(OverlayStore.Events.OverlayDestroyed, () => {

      MapActions.EditOverlayEnd.dispatch(true);

      SaturnGrowl.newGrowl(`The overlay "${ data.name }" has been deleted successfully`, {
        id:'overlay-deleted',
        time: 2000
      });
    });
  });

  //////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////

  const onSelectedItem = (ev, data) => {

    const overlayId = data.item.id;
    OverlayStore.activate(overlayId);
    ev.stopPropagation();
  };

  const onDeselectedItem = (ev, data) => {

    const overlayId = data.item.id;
    OverlayStore.deactivate(overlayId);
    ev.stopPropagation();
  };

  vm.handlePermissionError = () => {

    $rootScope.$broadcast('dialog:overlay:permissionsError');
  };

  $scope.$on('list:deselectedItem', onDeselectedItem);
  $scope.$on('list:selectedItem', onSelectedItem);

  OverlayStore.on(OverlayStore.Events.OverlayDestroyed, _loadOverlays);
  OverlayStore.on(OverlayStore.Events.PermissionError, vm.handlePermissionError.bind(vm), $scope);

  // Initialization section

  _loadOverlays();
};

OverlayListController.$inject = [
  '$scope', '$rootScope', 'sbFlux', 'NavActions', 'SaturnGrowl', 'IdentityService'
];

module.exports = OverlayListController;



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/overlays/list/OverlayListController.js